import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
}from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2:{
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  boldText: {
    fontFamily: 'Roboto',
    fontWeight: 'ultrabold'
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration:'underline'
  },
  columnHeader: {
    width: '10%',
    backgroundColor:'#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '12%',
    padding: 3,
    textAlign: 'center',
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};
const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const TpaClaimAmountReportStatusPdf = ({ data }) => {
  console.log(data);
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="TPA Claim Amount Status Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <View style={styles.row}>
              <Text style={{...styles.columnHeader, width:'10%'}} content="Sr No." />
              <Text style={{ ...styles.columnHeader, width: '20%' }} content="Patient Name" />
              <Text style={{ ...styles.columnHeader, width: '25%' }} content="Claim Id" />
              <Text style={styles.columnHeader} content="Uhid No." />
              <Text style={styles.columnHeader} content="Adm No" />
              <Text style={styles.columnHeader} content="Initial Amt" />
              <Text style={{ ...styles.columnHeader, width: '20%' }} content="Claim Amt" />                                                                                          
              <Text style={{ ...styles.columnHeader, width: '17%' }} content="Approved Amt." />
              <Text style={{...styles.columnHeader, width: '13%'}} content="Sponsor" />
              <Text style={{ ...styles.columnHeader,  }} content="Rec Amt." />
              <Text style={{ ...styles.columnHeader,  }} content="TDS Amt" />
              <Text style={{ ...styles.columnHeader,  }} content="Hosp. Disc" />
              <Text style={{ ...styles.columnHeader,  }} content="Co Pay" />
              <Text style={{ ...styles.columnHeader,  }} content="Other Charges" />
            </View>
            {data &&
              data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{...styles.columnContent, width:'10%'}} content={index + 1} />
                  <Text style={{ ...styles.columnContent, width: '20%', textAlign:'left' }}
                    content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`} />
                  <Text style={{ ...styles.columnContent, width: '25%', textAlign:'left' }}
                    content={data.claim_id} />
                  <Text style={styles.columnContent} content={data.uhid} />
                  <Text style={styles.columnContent} content={data.ipd_no} />
                  <Text style={{...styles.columnContent, textAlign:'left'}} content={data.initial_amt} />
                  <Text style={{ ...styles.columnContent, width: '20%', textAlign:'left' }} content={data.claim_amt} />
                  <Text style={{ ...styles.columnContent, width: '17%', textAlign:'left' }} content={data.approved_amt} />
                  <Text style={{...styles.columnContent, width: '11%', textAlign:'left' }} content={data.patient.sponsor.name} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={data.received_amt} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={data.tds_amt} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={data.co_payment} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={data.other_charges} />
                </View>
              ))}
          
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};


